import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Dropdown, ButtonGroup } from 'react-bootstrap'

function FontSizeDropdown(props) {
  const { fontSize, getFontSize } = props

  const FONT_10 = 10
  const FONT_20 = 20
  const FONT_30 = 30
  const FONT_40 = 40
  const FONT_50 = 50

  const [selectedFontSize, setSelectedFontSize] = useState(fontSize)

  const handleSelectedFontSize = (e) => {
    e = parseInt(e, 10)
    setSelectedFontSize(e)
    getFontSize(e)
  }

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <ButtonGroup
      href=''
      ref={ref}
      onClick={(e) => {
        e.preventDefault()
        onClick(e)
      }}
    >
      {children}
      &#9650;
    </ButtonGroup>
  ))

  return (
    <Dropdown drop='up'>
      <Dropdown.Toggle as={CustomToggle} id='dropdown-custom-components'>
        {selectedFontSize}pt
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item eventKey={FONT_10} active={selectedFontSize === FONT_10} onSelect={handleSelectedFontSize}>
          {FONT_10}pt
        </Dropdown.Item>
        <Dropdown.Item eventKey={FONT_20} active={selectedFontSize === FONT_20} onSelect={handleSelectedFontSize}>
          {FONT_20}pt
        </Dropdown.Item>
        <Dropdown.Item eventKey={FONT_30} active={selectedFontSize === FONT_30} onSelect={handleSelectedFontSize}>
          {FONT_30}pt
        </Dropdown.Item>
        <Dropdown.Item eventKey={FONT_40} active={selectedFontSize === FONT_40} onSelect={handleSelectedFontSize}>
          {FONT_40}pt
        </Dropdown.Item>
        <Dropdown.Item eventKey={FONT_50} active={selectedFontSize === FONT_50} onSelect={handleSelectedFontSize}>
          {FONT_50}pt
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}

FontSizeDropdown.propTypes = {
  fontSize: PropTypes.number.isRequired,
  getFontSize: PropTypes.func.isRequired,
}

export default FontSizeDropdown
